import type { UvInsertsBootstrapPayload } from "@shared/models/uv-inserts"

declare global {
  interface Window {
    /** Raw JSON from Liquid; normalised by {@link readUvInsertsBootstrapPayload}. */
    uvInsertsConfig?: unknown
  }
}

/**
 * Reads UV inserts bootstrap data from the theme Liquid snippet.
 * This is the only place that should read `window.uvInsertsConfig`.
 */
export function readUvInsertsBootstrapPayload(): UvInsertsBootstrapPayload {
  const raw = window.uvInsertsConfig as Record<string, unknown> | undefined
  if (!raw || typeof raw !== "object") {
    return { configs: [], templateIds: {} }
  }
  return {
    configs: Array.isArray(raw.configs) ? raw.configs : [],
    templateIds:
      raw.templateIds !== null &&
      raw.templateIds !== undefined &&
      typeof raw.templateIds === "object" &&
      !Array.isArray(raw.templateIds)
        ? (raw.templateIds as Record<number | string, string | null>)
        : {},
    suggestedMessaging: Array.isArray(raw.suggestedMessaging) ? raw.suggestedMessaging : undefined,
  }
}
